export default function TermoDeUso() {
  const container = document.createElement('div');
  container.className = 'content termodeuso-container';

  // Card de título
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Termos de Uso - Mobi Light</h2>`;
  container.appendChild(header);

  // Card do conteúdo
  const contentCard = document.createElement('div');
  contentCard.className = 'card';
  contentCard.innerHTML = `
    <p style="font-size:13px;color:#aaa;text-align:left;">
      Atualizado em 12/10/2026 09:50:35 -03
    </p>

    <div style="text-align:left;font-size:14px;color:#ccc;line-height:1.6;">
      <h3>1. Aceite dos termos</h3>
      <p>Ao acessar ou usar o aplicativo Mobi Light, você concorda com estes Termos de Uso. Se você não concordar com estes termos, não utilize o aplicativo.</p>
      <p>O aplicativo foi desenvolvido para apoiar o uso operacional do equipamento Mobi Light, incluindo cadastro de pacientes, acompanhamento de terapias, sincronização de dados e conexão com hardware por Bluetooth Low Energy.</p>

      <h3>2. Uso autorizado</h3>
      <p>O aplicativo deve ser utilizado apenas por usuários, profissionais, empresas ou representantes autorizados. O usuário é responsável por manter suas credenciais protegidas e por todas as atividades realizadas em sua conta.</p>
      <p>Você concorda em usar o aplicativo de acordo com a legislação aplicável, boas práticas profissionais, orientações técnicas do equipamento e políticas internas da empresa responsável pelo atendimento.</p>

      <h3>3. Equipamento Mobi Light</h3>
      <p>O aplicativo pode se conectar ao equipamento Mobi Light para executar fluxos operacionais e enviar comandos. O usuário deve garantir que o equipamento esteja em condições adequadas, configurado corretamente e utilizado conforme instruções técnicas, clínicas e regulatórias aplicáveis.</p>
      <p>O aplicativo não substitui manuais, treinamentos, recomendações profissionais, validações técnicas ou avaliação clínica.</p>


      <h3>4. Pacientes, terapias e responsabilidade profissional</h3>
      <p>O usuário é responsável pela exatidão dos dados cadastrados, pela seleção correta de pacientes, pela indicação adequada de terapias e pelo uso das informações exibidas no aplicativo.</p>
      <p>Qualquer decisão clínica, terapêutica ou operacional deve ser tomada por profissional habilitado, quando aplicável.</p>

      <h3>5. Conta, segurança e acesso</h3>
      <p>Você deve manter login e senha em sigilo, usar somente contas autorizadas e comunicar qualquer suspeita de acesso indevido. Podemos suspender ou limitar acesso em caso de risco, uso irregular, violação destes termos ou necessidade técnica.</p>

      <h3>6. Sincronização, modo offline e disponibilidade</h3>
      <p>O aplicativo pode armazenar dados localmente e sincronizar com servidores remotos quando houver conexão. Em modo offline, dados podem ficar pendentes de sincronização.</p>
      <p>Não garantimos disponibilidade contínua, ausência de falhas, compatibilidade com todos os dispositivos ou funcionamento ininterrupto de rede, Bluetooth, servidores, sistemas operacionais ou serviços de terceiros.</p>

      <h3>7. Permissões do dispositivo</h3>
      <p>Alguns recursos dependem de permissões do aparelho, como Bluetooth, localização, rede, armazenamento seguro e WebView. A recusa ou revogação de permissões pode impedir partes do funcionamento do aplicativo.</p>

        <h3>8. Condutas proibidas</h3>
      <ul style="margin-left:20px; color:#ccc; font-size:14px; line-height:1.6;">
        <li>Usar o aplicativo para fins ilegais, inseguros ou não autorizados.</li>
        <li>Tentar acessar dados, contas, servidores ou equipamentos sem autorização.</li>
        <li>Interferir no funcionamento do aplicativo, do servidor ou do equipamento.</li>
        <li>Copiar, modificar, distribuir, realizar engenharia reversa ou explorar o aplicativo sem autorização.</li>
        <li>Inserir dados falsos, ofensivos, indevidos ou que violem direitos de terceiros.</li>
      </ul>

      <h3>9. Propriedade intelectual</h3>
      <p>O aplicativo, marcas, interfaces, códigos, fluxos, textos e demais elementos pertencem aos respectivos titulares e licenciantes. Nenhum direito de propriedade intelectual é transferido ao usuário pelo uso do aplicativo.</p>

      <h3>10. Privacidade</h3>
      <p>O tratamento de dados pessoais é descrito na Política de Privacidade do Mobi Light. Ao usar o aplicativo, você também declara ciência da política aplicável.</p>

      <h3>11. Atualizações</h3>
      <p>Podemos alterar, corrigir, atualizar, suspender ou descontinuar recursos do aplicativo a qualquer momento, especialmente por motivos técnicos, de segurança, compatibilidade, regulação ou melhoria do serviço.</p>

      <h3>12. Limitação de responsabilidade</h3>
      <p>Na máxima extensão permitida pela lei, não nos responsabilizamos por danos indiretos, lucros cessantes, perda de dados, falhas de conectividade, uso incorreto do equipamento, decisões profissionais inadequadas ou uso em desacordo com estes termos e instruções aplicáveis.</p>

      <h3>13. Suporte</h3>
      <p>Para suporte, acesse Suporte Mobi Light.</p>

      <h3>14. Alterações destes termos</h3>
      <p>Estes termos podem ser atualizados periodicamente. A data de atualização será indicada no início do documento. O uso continuado do aplicativo após alterações indica concordância com a versão atualizada.</p>

    </div>

    <p class="rodape" style="margin-top:20px;font-size:13px;color:#aaa;text-align:left;">
      Para suporte, acesse Suporte Mobi Light.<br>
      Veja também a Política de Privacidade.
    </p>
  `;
  container.appendChild(contentCard);

  return container;
}
